/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useCallback, useMemo, useRef, useContext } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Container,
  Row,
} from 'reactstrap';

import TipoDeAtendimento from '../../components/Especialidade';
import TableManager from '../../components/TableManager';
import { AppContext } from '../../contexts/app';
import { useManager } from '../../hooks/manager';
import api from '../../services/api';

// nome anterior Especialidades - alterado para TipoDeAtendimentos 17/11/2023 18:13
function TipoDeAtendimentos() {
  const notificationRef = useRef();
  const { setLoading } = useContext(AppContext);
  const especialidadeRef = useRef();
  const { load, destroy } = useManager();

  useEffect(() => {
    load('/especialidades', 1, []);
  }, [load]);

  const handleUpdate = useCallback((data) => {
    especialidadeRef.current.show(data);
  }, []);

  const handleCreate = useCallback(() => {
    especialidadeRef.current.show();
  }, []);

  const handleCreateCsv = useCallback((_selectedRows = []) => {
    (async () => {
      try {
        setLoading({
          loading: true,
          message: 'Aguarde... Estamos gerando o arquivo CSV... ',
        });

        // await fetch api
        const res = await api.post('/tipoAtendimentoCSVCreatorReportLists', { tipoAtendimentosIds: _selectedRows.map(({ _id }) => _id) }, { responseType: 'blob' });
        const fileName = res.headers['content-disposition']
          .replace('attachment; filename=', '')
          .replace('"', '');

        const fileURL = window.URL.createObjectURL(res.data);
        const alink = document.createElement('a');
        alink.href = fileURL;
        alink.target = '_blank';
        alink.rel = 'noopener noreferrer';
        alink.download = fileName;
        alink.click();

        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.error(err);

        if (err && err.response && err.response.data) {
          const { message } = err.response.data;

          if (message) {
            notificationRef.current.notify({
              message,
              color: 'danger',
            });

            return;
          }
        }

        notificationRef.current.notify({
          message: 'Falha ao realizar ao gerar relatório',
          color: 'danger',
        });
      }
    })();
  }, [notificationRef, setLoading]);

  const columns = useMemo(() => [
    {
      dataField: 'nome',
      text: 'Nome',
      textFilter: true,
      width: '100%',
    },
    {
      dataField: 'cor',
      text: 'Cor',
      formatter: (row) => (
        <div style={{ backgroundColor: row.cor, width: '20px', height: '20px', borderRadius: '10px' }} />
      ),
      width: '100%',
    },
  ]);

  return (
    <Container fluid>
      <Row className="mt-5">
        <Col>
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <h3>Tipo de Atendimentos</h3>
                </Col>
              </Row>
            </CardBody>
            <CardFooter>
              <Row>
                <Col>
                  <Row>
                    <Col xs={12} sm={5} md={3} className="mb-3 mb-xl-0">
                      <Button block color="success" onClick={handleCreate}>
                        Cadastrar
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardFooter>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <TableManager
            initialColumns={columns}
            onCreateCsv={handleCreateCsv}
            onUpdate={(row) => handleUpdate(row)}
            onDelete={(row) => destroy(row._id, '/especialidades')}
            selectable
          />
        </Col>
      </Row>
      <TipoDeAtendimento ref={especialidadeRef} />
    </Container>
  );
}

export default TipoDeAtendimentos;
